import { useNavigate } from "react-router-dom";
import { LayoutGrid, BookOpen } from "lucide-react";
import { useTabs } from "../../contexts/TabsContext";

// Segmented ERP / Docs switch that lives in the top bar of both workspaces.
// `active` marks the current workspace; the other segment navigates across.
const ITEMS = [
  { key: "erp", label: "ERP", icon: LayoutGrid, to: "/" },
  { key: "docs", label: "Docs", icon: BookOpen, to: "/docs" },
];

const WorkspaceToggle = ({ active = "erp", className = "" }) => {
  const navigate = useNavigate();
  const { openInNewTab } = useTabs();

  return (
    <div
      role="tablist"
      aria-label="Workspace"
      className={`inline-flex items-center gap-0.5 rounded-full bg-muted/60 p-0.5 ${className}`}
    >
      {ITEMS.map(({ key, label, icon: Icon, to }) => {
        const isActive = key === active;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-testid={`workspace-${key}`}
            onClick={() => !isActive && navigate(to)}
            onMouseDown={(e) => {
              if (e.button === 1 && e.ctrlKey) e.preventDefault(); // ctrl+middle-click opens an ERP tab instead
            }}
            onAuxClick={(e) => {
              if (e.button === 1 && e.ctrlKey) {
                e.preventDefault();
                openInNewTab(to, label);
              }
              // plain middle-click: no href to open, so this is a no-op
            }}
            className={`flex items-center gap-1.5 h-7 px-3 rounded-full text-xs font-heading font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
              isActive
                ? "bg-card text-primary shadow-[0_1px_2px_rgba(0,0,0,0.06)] ring-1 ring-border/50 dark:shadow-[0_1px_2px_rgba(0,0,0,0.4)]"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default WorkspaceToggle;
